// useAddInsertConvergence.js
import { useState } from "react";
import { axiosApi } from '../../api/setupApi';

export default function useAddInsertConvergence() {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  async function upsertRows(rows) {
    setSaving(true);
    setError(null);
    try {
      const { data } = await axiosApi.post('/convergence/upsert', rows);
      return data;
    } catch (err) {
      console.error("Upsert failed:", err);
      setError(err);
      throw err;
    } finally {
      setSaving(false);
    }
  }

  return { upsertRows, saving, error };
}
